import { useContext } from "react";
import AlertNoticeContext from "./AlertNoticeContext";

export const useAlertNoticeContext = () => useContext(AlertNoticeContext);
